(function () {
  'use strict';
  if (window.LuxsterGarageController || !window.LuxsterVehicle) return;
  var initialDialog = document.querySelector('[data-vehicle-garage]');
  if (!initialDialog) return;
  var engine = window.LuxsterVehicle;
  var dialog, copy, list, garageView, editor;
  var editorWanted = false;
  var opener = null;
  var lastList = '';
  var switchingVehicle = false;

  function focusTitle() {
    dialog.querySelector('#LuxsterGarageTitle').focus({ preventScroll: true });
  }

  function updateViewport() {
    if (!dialog || !dialog.open) return;
    var viewport = window.visualViewport;
    var height = viewport ? viewport.height : window.innerHeight;
    var top = viewport ? viewport.offsetTop : 0;
    dialog.style.setProperty('--garage-viewport-height', height + 'px');
    dialog.style.setProperty('--garage-center-y', (top + height * 0.46) + 'px');
    dialog.style.setProperty('--garage-max-height', Math.max(120, Math.floor(height * 0.92 - 32)) + 'px');
  }

  function onDialogPointerDown() {
    dialog.dataset.inputMode = 'pointer';
  }

  function onDialogKeyDown(event) {
    if (['Tab', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End', 'PageUp', 'PageDown', 'Enter', ' '].indexOf(event.key) !== -1) {
      dialog.dataset.inputMode = 'keyboard';
    }
  }

  function vehicleName(vehicle) {
    return [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' ');
  }

  function focusField() {
    requestAnimationFrame(function () {
      if (!dialog.open || editor.hidden) return;
      var fields = Array.from(editor.querySelectorAll('[data-vehicle-field]:not(:disabled)'));
      var target = fields.find(function (field) { return !field.value; }) || fields[0];
      if (target) target.focus({ preventScroll: true });
    });
  }

  function actionButton(className, text, action, id) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.textContent = text;
    button.dataset.vehicleAction = action;
    button.dataset.vehicleId = id;
    return button;
  }

  function renderList(state) {
    var busy = switchingVehicle || !!state.submitting;
    var signature = JSON.stringify([state.vehicles, state.activeId, state.ready, busy]);
    if (signature === lastList) return;
    lastList = signature;
    var focused = document.activeElement;
    var focusedId = focused && focused.dataset.vehicleId;
    var focusedAction = focused && focused.dataset.vehicleAction;
    var fragment = document.createDocumentFragment();
    state.vehicles.forEach(function (vehicle) {
      var name = vehicleName(vehicle);
      var row = document.createElement('article');
      row.className = 'luxster-garage__vehicle';
      row.dataset.vehicleAction = 'activate';
      row.dataset.vehicleId = vehicle.id;
      row.setAttribute('aria-busy', String(busy));
      var choice = document.createElement('label');
      choice.className = 'luxster-garage__choice';
      var radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'luxster-garage-main';
      radio.value = vehicle.id;
      radio.checked = state.activeId === vehicle.id;
      radio.disabled = busy;
      radio.dataset.vehicleId = vehicle.id;
      radio.dataset.vehicleAction = 'activate';
      var title = document.createElement('strong');
      title.textContent = name;
      choice.append(radio, title);
      if (radio.checked) {
        var main = document.createElement('span');
        main.className = 'luxster-garage__main';
        main.textContent = copy.main;
        choice.append(main);
      }
      var remove = actionButton('luxster-garage__delete', '', 'remove', vehicle.id);
      remove.disabled = busy;
      remove.setAttribute('aria-label', copy.remove + ': ' + name);
      var trash = document.createElement('i');
      trash.className = 'linearicons-trash';
      trash.setAttribute('aria-hidden', 'true');
      remove.append(trash);
      row.append(choice, remove);
      if (vehicle.position) {
        var position = document.createElement('p');
        position.className = 'luxster-garage__position';
        position.textContent = vehicle.position;
        row.append(position);
      }
      fragment.append(row);
    });
    list.replaceChildren(fragment);
    if (focusedId) {
      var replacement = Array.from(list.querySelectorAll('input[data-vehicle-id], button[data-vehicle-id]')).find(function (element) {
        return element.dataset.vehicleId === focusedId && element.dataset.vehicleAction === focusedAction;
      });
      if (replacement) replacement.focus({ preventScroll: true });
      else if (dialog.open) dialog.querySelector('[data-vehicle-add]').focus({ preventScroll: true });
    }
  }

  function render(state) {
    var selected = state.complete || (!state.ready && state.selection.year && state.selection.make && state.selection.model);
    var desktopName = selected ? vehicleName(state.selection) : copy.yourVehicle;
    var mobileName = selected ? [state.selection.year, state.selection.make].join(' ') : copy.yourVehicle;
    document.querySelectorAll('[data-vehicle-toggle]').forEach(function (button) {
      button.querySelector('[data-vehicle-label-desktop]').textContent = desktopName;
      button.querySelector('[data-vehicle-label-mobile]').textContent = mobileName;
      button.title = desktopName;
      button.setAttribute('aria-label', desktopName);
      button.setAttribute('aria-expanded', String(dialog.open));
      button.classList.toggle('has-vehicle', !!selected);
    });
    var busy = switchingVehicle || !!state.submitting;
    dialog.querySelector('[data-vehicle-clear]').disabled = busy || (!state.vehicles.length && !Object.values(state.selection).some(Boolean));
    dialog.querySelector('[data-vehicle-add]').disabled = busy;
    dialog.querySelector('[data-vehicle-empty]').hidden = !!state.vehicles.length;
    dialog.querySelector('[data-vehicle-back]').hidden = !state.vehicles.length;
    garageView.hidden = editorWanted;
    editor.hidden = !editorWanted;
    renderList(state);
  }

  function open(button) {
    opener = button;
    editorWanted = !engine.getState().vehicles.length;
    engine.load();
    render(engine.getState());
    dialog.showModal();
    updateViewport();
    focusTitle();
    render(engine.getState());
  }

  function selectSavedVehicle(id) {
    if (switchingVehicle || engine.getState().submitting) return;
    switchingVehicle = true;
    var status = dialog.querySelector('[data-vehicle-garage-status]');
    status.textContent = '';
    status.hidden = true;
    // activate restores the saved Position as well as Year/Make/Model. The
    // shared submit waits for data validation and resolves its matching parts.
    if (engine.activate(id) === false) {
      switchingVehicle = false;
      render(engine.getState());
      return;
    }
    Promise.resolve().then(function () {
      return engine.submit(dialog.dataset.resultPage);
    }).catch(function (error) {
      status.textContent = error.message;
      status.hidden = false;
    }).finally(function () {
      switchingVehicle = false;
      render(engine.getState());
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-vehicle-toggle]');
    if (toggle) {
      if (dialog.open) dialog.close();
      else open(toggle);
    }
  });
  document.addEventListener('luxster:vehicle:navigate', function () {
    // The results region takes over immediately; do not keep a busy garage
    // covering the new page while its product request completes.
    if (dialog.open) dialog.close();
  });
  function onDialogClick(event) {
    if (event.target === dialog || event.target.closest('[data-vehicle-close]')) {
      dialog.close();
      return;
    }
    if (switchingVehicle || engine.getState().submitting) return;
    if (event.target.closest('[data-vehicle-clear]')) {
      editorWanted = true;
      engine.clear();
      focusField();
      return;
    }
    if (event.target.closest('[data-vehicle-add]')) {
      editorWanted = true;
      engine.add();
      focusField();
      return;
    }
    if (event.target.closest('[data-vehicle-back]')) {
      editorWanted = false;
      render(engine.getState());
      focusTitle();
      return;
    }
    var target = event.target.closest('[data-vehicle-action]');
    if (!target) return;
    var action = target.dataset.vehicleAction;
    var id = target.dataset.vehicleId;
    if (action === 'remove') {
      event.preventDefault();
      engine.remove(id);
      if (!engine.getState().vehicles.length) {
        editorWanted = true;
        render(engine.getState());
        focusField();
      }
    } else if (action === 'activate') {
      // Cancel the label's synthetic input click: one card interaction must
      // produce exactly one activation and submission, including active rows.
      event.preventDefault();
      selectSavedVehicle(id);
    }
  }
  function onDialogChange(event) {
    if (event.target.matches('input[data-vehicle-action="activate"]')) selectSavedVehicle(event.target.dataset.vehicleId);
  }
  function onDialogClose() {
    render(engine.getState());
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  }
  function bindDialog(nextDialog) {
    if (dialog === nextDialog) return;
    if (dialog && dialog.open) dialog.close();
    dialog = nextDialog;
    copy = JSON.parse(dialog.querySelector('[data-vehicle-copy]').textContent);
    list = dialog.querySelector('[data-vehicle-list]');
    garageView = dialog.querySelector('[data-vehicle-garage-view]');
    editor = dialog.querySelector('[data-vehicle-editor]');
    lastList = '';
    dialog.addEventListener('click', onDialogClick);
    dialog.addEventListener('change', onDialogChange);
    dialog.addEventListener('close', onDialogClose);
    dialog.addEventListener('pointerdown', onDialogPointerDown, true);
    dialog.addEventListener('keydown', onDialogKeyDown, true);
  }
  document.addEventListener('shopify:section:load', function () {
    var nextDialog = document.querySelector('[data-vehicle-garage]');
    if (nextDialog) bindDialog(nextDialog);
    render(engine.getState());
  });
  bindDialog(initialDialog);
  engine.subscribe(render);
  window.addEventListener('resize', updateViewport);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateViewport);
    window.visualViewport.addEventListener('scroll', updateViewport);
  }
  window.LuxsterGarageController = { open: open };
  var boot = window.LuxsterVehicleBoot;
  if (boot && boot.pendingOpener) {
    var pendingOpener = boot.pendingOpener;
    boot.pendingOpener = null;
    if (pendingOpener.isConnected) open(pendingOpener);
  }
})();
